module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "prelims-page",
    attrs: {
      "id": "d3ce853440f00-d1e211"
    }
  }, [_c('span', {
    attrs: {
      "id": "pageii"
    }
  }, [_c('h3', {
    staticClass: "books-by-head"
  }, [_c('em', {
    staticClass: "char-italic italic"
  }, [_vm._v("A Selection of Titles by Phillip DePoy")])]), _vm._v(" "), _c('h4', {
    staticClass: "books-by-subtitle"
  }, [_c('em', {
    staticClass: "char-italic italic"
  }, [_vm._v("The Fever Devilin Series")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("THE DEVIL’S HEARTH")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("THE WITCH’S GRAVE")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("A MINISTER’S GHOST")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("A WIDOW’S CURSE")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("THE DRIFTER’S WHEEL")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("A CORPSE’S NIGHTMARE")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_vm._v("DECEMBER’S THORN")]), _vm._v(" "), _c('h4', {
    staticClass: "books-by-subtitle"
  }, [_c('em', {
    staticClass: "char-italic italic"
  }, [_vm._v("The Foggy Moskowitz Series")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_vm._v("COLD FLORIDA *")]), _vm._v(" "), _c('h4', {
    staticClass: "books-by-subtitle"
  }, [_c('em', {
    staticClass: "char-italic italic"
  }, [_vm._v("* available from Severn House")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ab94598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781780107394_epub_alb.vue
// module id = 63
// module chunks = 0